import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { LoanService } from '../../services/loan.service';

import { Utils } from '../../util';

@Component({
    selector: 'app-display-loan',
    templateUrl: './display-loan.component.html',
    styleUrls: ['./display-loan.component.css', '../../app.component.css']
})

export class DisplayLoanComponent implements OnInit {

    loan: any = [];

    id: string;

    glSubs: any;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private loanService: LoanService) {
        
        this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            this.glSubs = this.loanService.getLoan(this.id).subscribe(loanObj => {
                this.glSubs.unsubscribe();

                this.loan = loanObj;

                this.loan.loanDate = Utils.convertDatefromStringtoISOString(this.loan.loanDate);
            });

            
        });
    }

    ngOnInit() {

    }

}
